import { ColoredProfile, EventThread } from "@clockwise/web-commons/src/ui/event-thread/";
import { useReadCalendarColors } from "@clockwise/web-commons/src/util/CalendarColorsContext";
import { isEmpty } from "lodash";
import React from "react";
import { TradeoffItem } from "../../../../../event-card/molecules/ECTradeoffList";
import { TradeoffBlock } from "../../../utils/types";

export const TradeoffsSummary = ({ tradeoffs }: { tradeoffs: TradeoffBlock[] }) => {
  const calendarColorMap = useReadCalendarColors();
  const schedulingTradeoffsWithOutEventId = tradeoffs
    .map((tradeoff) => tradeoff.schedulingTradeoffs)
    .flat()
    .filter((tradeoff) => isEmpty(tradeoff.externalEventId));

  if (!schedulingTradeoffsWithOutEventId.length) {
    return null;
  }

  const coloredProfiles: ColoredProfile[] = schedulingTradeoffsWithOutEventId
    .map((schedulingTradeoff) => {
      const { attendees } = schedulingTradeoff;
      return attendees.map((attendee) => {
        const color = calendarColorMap[attendee?.primaryCalendarId]?.border || "";
        const profile = {
          givenName: attendee?.profile?.givenName || null,
          familyName: attendee?.profile?.familyName || null,
          externalImageUrl: attendee?.profile?.externalImageUrl || null,
        };
        return { color, profile };
      });
    })
    .flat();

  return (
    <>
      <EventThread.Event coloredProfiles={coloredProfiles}>
        <div className="cw-w-full cw-py-2 cw-px-3 cw-flex-col cw-bg-neutral cw-border cw-border-solid cw-border-muted cw-rounded-xl cw-body-sm cw-font-medium">
          <div className="cw-flex-col">
            {schedulingTradeoffsWithOutEventId.map((schedulingTradeoff, index) => (
              <div
                key={`${schedulingTradeoff.title}-${index}`}
                className="cw-flex-col cw-justify-between cw-w-full"
              >
                <TradeoffItem tradeoff={schedulingTradeoff} variant="warning" />
              </div>
            ))}
          </div>
        </div>
      </EventThread.Event>
    </>
  );
};
